import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partners: {
        list_partners: {
          tracker_settings: {
            tabs: {
              main_data: {
                tab_name: 'TAB_NAME',
                max_count_trackers: 'MAIN_FORM_MAX_COUNT_TRACKERS',
                current_count_tracker: 'MAIN_FORM_CURRENT_COUNT_TRACKER',
              },
            },
          },
        },
      },
    },
  }));
}
